import {
  Autocomplete,
  Card,
  CardContent,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { HiOutlineWallet } from "react-icons/hi2";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { BiRefresh } from "react-icons/bi";
import { Wallet } from "../../../../app/slices/walletSlice";
import { TONE } from "../../../../components/MobileList";
import { InfoCardHeader, StatTile, infoContentSx } from "../../../../components/InfoCard";

const months = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

const monthNumberToDate = (monthNumber) =>
  dayjs(`${dayjs().year()}-${monthNumber}-01`).format("YYYY-MM-DD");

// Shared between the "المعاملات المالية", "مناقلات الدفع الالكتروني" and
// "الدفع الالكتروني" tabs so all three show the same financial summary.
const FinancialInfoCard = () => {
  const dispatch = useDispatch();
  const { user_id } = useParams();
  const user = useSelector((state) => state.user.user.form);
  const _WalletReload = useSelector((state) => state.wallet.reload);
  const _MonthlyRep = useSelector((state) => state.wallet.monthlyRep);

  const [selectedMonth, setSelectedMonth] = useState(dayjs().format("MM"));

  useEffect(() => {
    if (user.is_representative)
      dispatch(
        Wallet.getMonthlyRep({
          rep_id: user_id,
          date: monthNumberToDate(selectedMonth),
        }),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id, _WalletReload, selectedMonth, user.is_representative]);

  return (
    <Card sx={{ height: "100%" }}>
      <InfoCardHeader
        icon={<HiOutlineWallet />}
        tone={TONE.success}
        title="المعلومات المالية"
      />
      <CardContent sx={infoContentSx}>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          <StatTile
            label="الرصيد"
            value={user.wallet?.balance}
            tone={TONE.success}
          />
          <StatTile
            label="الديون"
            value={user.wallet?.debt}
            tone={TONE.danger}
          />
          {user.is_representative ? (
            <StatTile label="الكاش" value={user.wallet?.cash} tone={TONE.brand} />
          ) : (
            <StatTile
              label="فرق الرصيد"
              value={user.wallet?.balance_difference}
              tone={TONE.neutral}
              action={
                <Tooltip title="اعادة حساب فرق الرصيد">
                  <IconButton
                    size="small"
                    sx={{ p: 0.25 }}
                    onClick={() =>
                      dispatch(Wallet.checkBalanceDifference(user.id))
                    }
                  >
                    <BiRefresh />
                  </IconButton>
                </Tooltip>
              }
            />
          )}
        </Stack>
        {user.is_representative ? (
          <Stack
            spacing={1}
            sx={{ mt: 1.25, pt: 1.25, borderTop: "1px dashed #eaecf0" }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body2" fontWeight={600} color="#344054">
                مبيعات المندوب لشهر:
              </Typography>
              <Autocomplete
                size="small"
                options={months}
                getOptionLabel={(option) => option}
                value={
                  months.filter((x) => x === selectedMonth)[0] ??
                  dayjs().format("MM")
                }
                onChange={(e, newValue) => {
                  setSelectedMonth(newValue ? newValue : dayjs().format("MM"));
                }}
                isOptionEqualToValue={(option, value) => option === value}
                renderInput={(params) => (
                  <TextField {...params} size="small" sx={{ width: 90 }} />
                )}
              />
            </Stack>
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {_MonthlyRep.data.total_income ? (
                <StatTile
                  label="إجمالي المبيعات"
                  value={_MonthlyRep.data.total_income}
                  tone={TONE.brand}
                />
              ) : null}
              {_MonthlyRep.data.total_e_payment ? (
                <StatTile
                  label="مبيعات الدفع الالكتروني"
                  value={_MonthlyRep.data.total_e_payment}
                  tone={TONE.success}
                />
              ) : null}
            </Stack>
          </Stack>
        ) : null}
      </CardContent>
    </Card>
  );
};

export default FinancialInfoCard;
